module.exports = __webpack_public_path__ + "images/no-photo-014e81a5.png";


//////////////////
// WEBPACK FOOTER
// ./_assets/no-photo.png
// module id = 1491
// module chunks = 0